import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        data-testid="app-error-boundary"
        className="min-h-screen flex items-center justify-center p-8 text-center"
      >
        <div className="max-w-md">
          <h1 className="font-display text-5xl">Something went wrong</h1>
          <p className="text-sm text-zinc-400 mt-4">
            Your athlete data is safe. Reload the page to continue — any unsaved athlete draft is
            kept on this device.
          </p>
          <button
            data-testid="error-reload-btn"
            onClick={() => window.location.reload()}
            className="mt-8 clip-slant bg-[#FF5A00] hover:bg-[#FF7B33] transition-colors px-7 py-4 text-xs font-bold uppercase tracking-[0.18em]"
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
